import $ from 'jquery';
import IMask from 'imask';

$.addInit(function(context){
	var base = '.i-phoneMask';
	var inputPhones = document.querySelectorAll(base);
	for (var i = 0; i < inputPhones.length; i++) {
		new IMask(inputPhones[i], {
			mask: '+{7}(000)000-00-00',
			lazy: false
		});
	}
});



//////////////////
// WEBPACK FOOTER
// ./src/components/i-phoneMask.js
// module id = 57
// module chunks = 0